import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { NotifyAlertService } from '@monorepo/ui';
import { EmailSubService } from './../services/email-sub.service';

@Component({
  selector: 'monorepo-email-subscription',
  templateUrl: './email-subscription.component.html',
  styleUrls: ['./email-subscription.component.scss'],
})
export class EmailSubscriptionComponent implements OnInit {
  subscribeForm: FormGroup;
  showSubscriptionForm: boolean = true;

  constructor(
    private fb: FormBuilder,
    private emailSubService: EmailSubService,
    private notifyAlertService: NotifyAlertService
  ) {}

  ngOnInit(): void {
    this.createSubscriptionForm();
  }

  private createSubscriptionForm(): void {
    this.subscribeForm = this.fb.group({
      emailId: ['', [Validators.required, Validators.email]],
    });
  }

  public submitSubscriptionForm(): void {
    const userEmailId: string = this.subscribeForm.value.emailId;
    this.emailSubService
      .addEmailToSubscription(userEmailId)
      .then((): void => {
        this.notifyAlertService.success('Thanks for the Subscribing');
        this.showSubscriptionForm = false;
        this.subscribeForm.reset();
      })
      .catch(() => {
        this.notifyAlertService.error('Something went wrong');
      });
  }
}
